import type React from "react"
import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { FullPageLoader } from "~/components/Loader"
import { useToast } from "~/utils"
import { trpc } from "~/utils/trpc"
import { setAuthToken } from "./util"

export const VerifyEmail: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const toast = useToast()
  const [isVerifying, setIsVerifying] = useState(true)
  const trpcContext = trpc.useContext()

  const { mutate: confirmEmailMutation } = trpc.authentication.confirmEmail.useMutation({
    onSuccess: (data) => {
      // Set the auth token to log the user in
      setAuthToken(data.token)
      
      // Invalidate user query to refresh user data
      trpcContext.users.me.invalidate()
      
      toast("success", "Email verified successfully! You can now use Arbeidsark.")
      // Redirect to home page
      navigate("/")
    },
    onError: (error) => {
      toast("error", "Failed to verify email. The link may be expired or invalid.")
      setIsVerifying(false)
      // Redirect to login after a delay
      setTimeout(() => {
        navigate("/login")
      }, 3000)
    },
  })

  useEffect(() => {
    const token = searchParams.get("token")
    
    if (token) {
      confirmEmailMutation({ token })
    } else {
      toast("error", "Invalid verification link")
      navigate("/login")
    }
  }, [searchParams])

  if (isVerifying) {
    return <FullPageLoader />
  }

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Email Verification Failed</h2>
      <p>Redirecting to login page...</p>
    </div>
  )
}